import { render, staticRenderFns } from "./FormGeo.vue?vue&type=template&id=79cd1c7a&"
import script from "./FormGeo.vue?vue&type=script&lang=js&"
export * from "./FormGeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports